<template>
  <v-btn-toggle
    v-model="toggle_chart"
    mandatory
    :class="align"
    color="#01579B"
    dense
    tile
    @change="emitChartSelector"
    background-color="white"
    group
  >
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="btn-chart" v-on="on" v-bind="attrs" :value="'Treemap'">
          <v-img :src="require('@/assets/iconos/bar-chart.svg')" width="24" />
        </v-btn>
      </template>
      <span>Treemap</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="btn-chart" v-on="on" v-bind="attrs" :value="'Dona'">
          <v-img :src="require('@/assets/iconos/pie-chart.svg')" width="24" />
        </v-btn>
      </template>
      <span>Pie</span>
    </v-tooltip>
  </v-btn-toggle>
</template>
<script>
export default {
  props: {
    align: {
      type: String,
      required: true
    }
  },
  methods: {
    emitChartSelector() {
      this.$emit('emitChartSelector', this.toggle_chart)
    }
  },
  data() {
    return {
      toggle_chart: 0
    }
  }
}
</script>
<style lang="sass" scoped>
.theme--light.v-btn.btn-chart
  &:before
    background-color: #fff !important
  &:hover, &.v-item--active
    background-color: #fff !important
    border: 2px solid var(--v-secondary-base) !important
    border-radius: 5px !important
</style>
